<template lang="pug">
div(v-if="availableCompanies.length >= 1")
  //- Show dropdown when multiple companies
  div(v-if="availableCompanies.length > 1")
    v-menu(v-model="showMenu" offset-y rounded="lg" min-width="200" max-width="300" :close-on-content-click="false" max-height="300")
      template(v-slot:activator="{ attrs }")
        y-button(v-bind="attrs" :label="selectedCompanyName" color="neutral400" outlined text-color="neutral700" size="xxs" append-icon="$yzi-chevron-down" icon-size="16" @click="toggleMenu")
      .white
        div(v-if="availableCompanies.length")
          .hover-bg(v-for="company in availableCompanies" :key="company.id" @click="selectCompany(company)")
            .d-flex.align-center.px-4.py-3
              .text-sm {{ company.name }}
            v-divider.basic300

  //- Show chip when only one company
  div(v-else-if="availableCompanies.length === 1")
    y-chip.chip.pa-1(:label="availableCompanies[0].name" color="blue" size="xs")
</template>

<script>
export default {
  name: 'CompanyDropdown',
  props: {
    companies: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedCompany: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    availableCompanies() {
      return this.companies || []
    },
    selectedCompanyName() {
      if (!this.selectedCompany) {
        return this.availableCompanies.length > 0 ? this.availableCompanies[0].name : 'No Company'
      }
      return this.selectedCompany.name
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    selectCompany(company) {
      this.showMenu = false
      this.$emit('company-selected', company)
    }
  }
}
</script>

<style scoped>
.hover-bg:hover {
  background-color: var(--v-neutral200) !important;
  cursor: pointer;
}

.chip {
  cursor: default !important;
}
</style>
